export default "__VITE_ASSET__9StX_ifs__"